import styles from './Obituary.module.scss'
import Hero from "@/Organisms/Page/Hero";
import Shortcuts from "@/Organisms/Page/Shortcuts";
import About from "@/Organisms/Page/About";
import Interactions from "@/Organisms/Page/Interactions";
import Actions from "@/Organisms/Page/Actions";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import {Interaction as InteractionType} from "@/types/interaction";

import PracticalInfo from "@/Organisms/Page/PracticalInfo";
import Photos from "@/Organisms/Photos/Photos";
import React from "react";
import Commercial, {CommercialType} from "@/Atoms/Commercial";
import useWindowSize from "@/helpers/useWindowSize";
import alert from "@/Atoms/Alert/Alert";
import SharePerson from "@/Molecules/Socials/SharePerson";
import ObituaryType from "@/types/ObituaryType";




export default function Page(
  {
    person,
    options,
    showInteractions,
    stats,
    interactions,
    onAddReply,
    onAddHeart,
    claimed,
    background,
    manualHeight,
    mobileMenuIsOpen,
    functions,
    flash
  }: {
  person: Person,
  options: any
  showInteractions: boolean,
  stats: InteractionStats,
  interactions: {
    data: InteractionType[],
    pages: number,
    page: number
  },
  onAddReply: (id: number, input: string) => Promise<any>,
  onAddHeart: (id: number) => Promise<boolean>,
  claimed?: boolean,
  background?: string,
  manualHeight?: number,
  mobileMenuIsOpen: boolean,
  functions?: {
    OnAddCondolence: () => void,
    OnAddFlower: () => void,
    OnAddCandle: () => void,
    OnSendCard: () => void,
    OnSendBouquet: () => void,
    OnSetMobileState: (state: boolean) => void,
  },
  flash: {
    message?: string
  }
}){

  const advertisementUrls = person.advertisements?.flatMap(ad =>
    ad.media.map(({ url }) => url as string)
  ) ?? [];
  const showReviewMessage = flash.message === 'need_reviewing';
  const hasPractical = person.practical && Object.keys(person.practical).length !== 0
  const hasPhotos = person.photos?.length > 0;
  const hasAbout = person.about?.length > 10  || person.characteristics?.length > 0
  const hasObituary = advertisementUrls.length > 0;
  const {isMobile} = useWindowSize()


  const handleDownload = (image: string, index: number) => {
    location.href = `/overlijdensberichten/${person.slug}/ad/${index}/download`
  }


  const handleInteract = (action: string) => {
    switch(action) {
      case 'condolence': functions?.OnAddCondolence(); break;
      case 'flower': functions?.OnAddFlower(); break;
      case 'candle': functions?.OnAddCandle(); break;
    }
  }

  const isPlatformHack = person.options?.platform_hack === true
  return <>
  <Hero
      person={person}
      stats={stats}
      claimed={claimed}
      background={background}
    />
    {!isPlatformHack && <Shortcuts
        hasPractical={hasPractical}
        hasPhotos={hasPhotos}
        isExtended={claimed ?? false}
        hasAbout={hasAbout}
        hasCondolences={showInteractions}
        hasObituary={hasObituary}/>}
    <section className={'p-5'}>
      <div className={`wrapper ${styles.wrapper}`}>

        <div className={styles.content}>

          {claimed && (<>

            {hasAbout && <About {...person} />}

            <div className={`${styles.group} md:hidden`}>
              {!isPlatformHack && <SharePerson person={person} />}
            </div>

            {isPlatformHack && <Photos
                images={advertisementUrls}
                onDownload={handleDownload}
            />}

            {showInteractions && <div className={'group'}>
              <Interactions
                isReactionMode={isPlatformHack}
                interactions={interactions}
                onAddReply={onAddReply}
                onAddHeart={onAddHeart}
                showReviewMessage={showReviewMessage}
                onInteract={handleInteract}
              />
            </div>}
            {hasPractical && <div className={'group'}>
              <h2><a id={'practical'}></a>Praktische informatie</h2>
              <PracticalInfo {...person.practical} />
            </div>}

            {hasPhotos && <div className={'group'}>
              <h2><a id={'photos'}></a>Foto's</h2>
              <Photos images={person.photos || []}/>
            </div>}

          </>)}


          {!claimed && (<>
            <div className={`${styles.group} md:hidden`}>
              {!isPlatformHack && <SharePerson person={person} />}
            </div>

            {/*{person.obituary_type === ObituaryType.Regular && isMobile &&*/}
            {/*  <div><Commercial*/}
            {/*    type={CommercialType.MediumRectangle}/></div>*/}
            {/*}*/}

            {isPlatformHack && <Photos
                images={advertisementUrls}
                onDownload={handleDownload}
            />}
            
            {showInteractions && <Interactions
              isReactionMode={isPlatformHack}
              interactions={interactions}
              onAddReply={onAddReply}
              onAddHeart={onAddHeart}
              showReviewMessage={showReviewMessage}
              onInteract={handleInteract}/>}
          </>)}

          {hasObituary && !isPlatformHack && <div className={'group mt-3'}>
            <h2><a id={'obituary'}></a>Overlijdensbericht</h2>
              <Photos
                  images={advertisementUrls}
                  onDownload={handleDownload}
              />
          </div>}

        </div>

        <Actions
          showInteractions={showInteractions}
          person={person}
          options={options}
          manualHeight={manualHeight}
          {...functions}
          isOpen={mobileMenuIsOpen}
        />
      </div>
    </section>
  </>
}
